import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import useSelectionsPrice from './useSelectionsPrice';

export default function useDisplayPrice(): number {
  const { selectedTrim, selectedYear, trims } = useContext(ParentModelContext);
  const selectionsPrice = useSelectionsPrice();
  const baseTrim =
    trims.data.results.find(trim => trim.priceAdd === 0) ??
    trims.data.results.at(0);

  return (
    selectionsPrice ||
    selectedTrim?.lowestPrice ||
    baseTrim?.lowestPrice ||
    selectedYear?.lowestPrice ||
    0
  );
}
